export default __webpack_public_path__ + "static/media/person-round-gray-small.81c8d2d8.svg";